import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'

import { RETURNS, CHECKOUT, SHIPPING, UNKNOWN } from '../assets/constant'

class Breadcrumb extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.setBreadcrumb = this.setBreadcrumb.bind(this)
  }

  setBreadcrumb() {
    if (this.props.title != CHECKOUT) {
      this.props.setBreadcrumb(this.props.title)
    }
  }

  render() {
    var layout = this.props.count == 3 ? "col-xs-6 col-md-4 offset-xs-3 offset-md-0" : "col-6"
    var selected = this.props.selected ? layout + " step active" : layout + " step"
    if (this.props.title == RETURNS && this.props.breadcrumb == SHIPPING){
      selected = layout + " step passed"
    }
    if (this.props.breadcrumb == CHECKOUT) {
      if (this.props.title != CHECKOUT) {
        selected = layout + " step passed"
      }
    }
    if (this.props.title == CHECKOUT) {
      selected += " checkout"
    }

    return (
      <div className={selected} onClick={this.setBreadcrumb}>
        <a href="#">{I18n.t('layouts.breadcrumb.' + this.props.title)}</a>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  breadcrumb: state.breadcrumb,
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Breadcrumb)


// WEBPACK FOOTER //
// ./app/javascript/components/components/Breadcrumb.jsx